import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import logoPsp from "../../assets/images/icon_home/logo-psp.svg";
import drop from "../../assets/images/icon_home/drop.svg";
import handLeft from "../../assets/images/icon_home/hand-left.svg";
import handRight from "../../assets/images/icon_home/hand-right.svg";
import notification from "../../assets/images/icon_home/notification.svg";
import arrowRight from "../../assets/images/icon_home/arrow-right.svg";
import wallet from "../../assets/images/icon_home/wallet.svg";
import all from "../../assets/images/icon_home/all.svg";
import card from "../../assets/images/icon_home/card.svg";
import addUser from "../../assets/images/icon_home/add-user.svg";
import transaction from "../../assets/images/icon_home/transaction.svg";
import mutation from "../../assets/images/icon_home/mutation.svg";
import attendance from "../../assets/images/icon_home/attendance.svg";
import invoice from "../../assets/images/icon_home/invoice.svg";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import info from "../../assets/images/icon_home/info.svg";
import banner from "../../assets/images/icon_stock/banner.png";

import users from "../../assets/images/icon_home/user.svg";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_balance from "../../core/service/api_balance";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";

import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Parallax, useParallax } from "react-scroll-parallax";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setBalance } from "../../core/feature/user/balanceSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { removeBalance } from "../../core/feature/balance/balanceSlice";
import TabsMobile from "../__template/TabsMobileComponent";
import { BottomSheet } from "react-spring-bottom-sheet";
import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { BrowserView, MobileView } from "react-device-detect";
import InfoDetailWeb from "./infoDetailWeb";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Typography } from "@material-tailwind/react";
import ReactGA from "react-ga4";

const InfoDetailMobile = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const env = Config.BaseUrlDev;
  const user: User = useAppSelector((state) => state.user.user);
  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useState({
    createTime: "2022-10-03T11:19:19",
    updateTime: "2022-10-10T10:58:36",
    companyId: "5f83b9fa28f6ab6e77b810d4",
    accountId: "5f83b9fb28f6ab6e77b810eb",
    isDeleted: false,
    title: "info",
    subtitle: "berita",
    isOpen: true,
    isHeadline: false,
    showTime: null,
    enable: false,
    tags: ["info", " siswa baru 7a", "11a"],
    description: "",
    viewCount: 0,
    urlFb: null,
    urlIg: null,
    urlDownload: null,
    latitude: null,
    longitude: null,
    image: "",
    imageOpt: ["", ""],
    isVideo: false,
    videoUrl: "",
    valueAdd: [],
    isAction: false,
    action: {
      name: null,
      inputValue: null,
      question: null,
      option: [],
      answer: null,
    },
    _id: "633a62c7ec01b49cdb3a521a",
  });
  const [imgOpt, setImgOpt] = useState<any>([]);
  const { id } = useParams();

  function onDismiss() {
    setOpen(false);
  }
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginRight: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginLeft: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    // afterChange: function (index: number) {
    //   console.log(
    //     `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
    //   );
    // },
  };

  const goToTop = () => {
    try {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  };

  function getDetail() {
    api_info.getDetailInfo(id).then((res: any) => {
      setData(res.data);
      setImgOpt(res.data.imageOpt);
    });
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getYtCode(str: String) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = str.match(regExp);
    let x = "";
    if (match && match[2].length == 11) {
      x = match[2];
    } else {
      //error
    }
    return String(x)
      .replace("/", "")
      .replace("v=", "")
      .replace("?", "")
      .replace("#", "");
  }

  useEffect(() => {
    setTimeout(() => {
      goToTop();
      console.log("to top");
    }, 100);
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, 0);
    getDetail();
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "News & Info Detail",
    });
  }, []);

  return (
    <>
      <BrowserView>
        <InfoDetailWeb />
      </BrowserView>
      <MobileView>
        <div className="min-h-screen h-full py-8 bg-psp-primary">
          <div className="px-8">
            <TabsMobile
              name={`${t("INFO.title")}`}
              backUrl={"info"}
            ></TabsMobile>
          </div>
          <section className="">
            <div className="h-full p-6">
              <div>
                <Slider {...settings}>
                  {data.image && (
                    <div className="justify-center flex flex-row w-80 max-h-60 shadow-sm relative">
                      <img
                        className=" w-full flex h-60 object-contain "
                        src={getImgContent(data.image)}
                        alt=""
                      />
                    </div>
                  )}
                  {imgOpt.length > 0 &&
                    imgOpt.map((item: any) => {
                      return (
                        <div className=" w-80 max-h-60 shadow-sm relative">
                          <img
                            className=" w-full h-60 object-cover"
                            src={getImgContent(item)}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  {data.videoUrl && (
                    <div className=" w-80 h-60 shadow-sm relative">
                      <iframe
                        className="h-full w-full"
                        width="100%"
                        height="100%"
                        allow="fullscreen"
                        src={`https://www.youtube.com/embed/${getYtCode(
                          data.videoUrl
                        )}`}
                      ></iframe>
                    </div>
                  )}
                  {data.imageOpt.length == 0 &&
                    data.image == "" &&
                    data.videoUrl == "" && (
                      <div className=" w-80 max-h-60 shadow-sm relative">
                        <LazyLoadImage
                          className="h-full w-full object-center"
                          effect="blur"
                          src={banner}
                        />
                      </div>
                    )}
                </Slider>
              </div>

              <div className="flex flex-col gap-1 mt-2 mb-4 p-2">
                <h5 className="font-montserrat m-0 font-normal text-xs text-left ">
                  {moment(data.updateTime).format("DD MMMM YYYY")}
                </h5>
                <h1 className="font-montserrat m-0 font-bold text-sm text-black text-left ">
                  {data.title}
                </h1>
                <h5 className="font-montserrat text-justify  m-0 font-normal text-sm text-black ">
                  {data.subtitle}
                </h5>

                <div className="mt-1.5">
                  <Typography variant="paragraph">
                    <p
                      className="text-sm whitespace-pre-wrap text-justify"
                      dangerouslySetInnerHTML={{ __html: data.description }}
                    />
                  </Typography>
                  {/* <p
                    className="text-justify text-sm font-montserrat normal-case"
                    dangerouslySetInnerHTML={{ __html: data.description }}
                  /> */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </MobileView>
    </>
  );
};

export default InfoDetailMobile;
